import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=29f9ca2e&"
import script from "./Group.vue?vue&type=script&lang=tsx&"
export * from "./Group.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports